/**
 * CP-03 Rush calendar, the same rule as the API's `weekendOf` (apps/api tournament.ts): a
 * Rush runs Friday 00:00 → Monday 00:00 UTC and its id is the Friday's date. Pure and tiny:
 * the manifest's badge and map check use it without loading the chunk.
 */
import { dayKey, weekday } from '@mp/core';

export const DAY_MS = 86_400_000;

export interface Weekend {
  /** the Friday's date (`YYYY-MM-DD`), the tournament id */
  id: string;
  opensAt: number;
  closesAt: number;
}

/** The Rush weekend containing `now`, or null from Monday to Thursday. */
export function weekendOf(now: number): Weekend | null {
  const day = Math.floor(now / DAY_MS);
  const wd = weekday(day); // 0 = Monday
  if (wd < 4) return null;
  const friday = day - (wd - 4);
  return { id: dayKey(friday), opensAt: friday * DAY_MS, closesAt: (friday + 3) * DAY_MS };
}

/** When the next Rush opens: the coming Friday (during a weekend, the Friday after it). */
export function nextOpensAt(now: number): number {
  const day = Math.floor(now / DAY_MS);
  const wd = weekday(day);
  return (day + (wd < 4 ? 4 - wd : 11 - wd)) * DAY_MS;
}

/** Level score as the server computes it: stars × 1,000 − whole seconds (a lost round scores 0). */
export function rushScore(won: boolean, stars: number, durationMs: number): number {
  return won ? Math.max(0, stars * 1000 - Math.floor(durationMs / 1000)) : 0;
}
